module.exports = __webpack_public_path__ + "static/media/basic.js.d146342d.map";